import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getOracle } from "../../utils/contractHelpers";
import { useEoaAccount } from "../useEoaAccount";

// import { useWeb3React } from "@web3-react/core";

const OracleWinners =  () => {
    const { account } = useEoaAccount();
    const web3 = useWeb3();
    const OracleWinnerHook = useCallback(
        async (address) => {
            const contract = getOracle(address, web3);
            try {
                const oraclewinner = await contract.methods.winnerOption().call();
                return oraclewinner;
            } catch (error) {
                console.error("Error fetching balance:", error.message || error);
                throw error;
            }
        },
        [web3, account]
    );
    return {OracleWinnerHook};
};

export default OracleWinners;